module.exports = __webpack_public_path__ + "img/Logo_Swiss_Tribology_transp_grey.bf6a17f0.png";